import { render, staticRenderFns } from "./DoAndWinHome.vue?vue&type=template&id=68348a8a&scoped=true&"
import script from "./DoAndWinHome.vue?vue&type=script&lang=js&"
export * from "./DoAndWinHome.vue?vue&type=script&lang=js&"
import style0 from "./DoAndWinHome.vue?vue&type=style&index=0&id=68348a8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68348a8a",
  null
  
)

export default component.exports